import ActionCard from './src/pages/CardSaga/ActionCard';
import ActionCreate from './src/pages/CardSaga/ActionCard/ActionCreate';
import ActionUpdate from './src/pages/CardSaga/ActionCard/ActionUpdate';
import PowerCard from './src/pages/CardSaga/PowerCard';
import PowerCreate from './src/pages/CardSaga/PowerCard/PowerCreate';
import PowerUpdate from './src/pages/CardSaga/PowerCard/PowerUpdate';
import AdventureCard from './src/pages/CardSaga/AdventureCard';
import AdventureCreate from './src/pages/CardSaga/AdventureCard/AdventureCreate';
import AdventureUpdate from './src/pages/CardSaga/AdventureCard/AdventureUpdate';
import Biome from './src/pages/CardSaga/Biome';
import BiomeCreate from './src/pages/CardSaga/Biome/BiomeCreate';
import BiomeUpdate from './src/pages/CardSaga/Biome/BiomeUpdate';
import CharacterClassCard from './src/pages/CardSaga/CharacterClassCard';
import CharacterClassCreate from './src/pages/CardSaga/CharacterClassCard/CharacterClassCreate';
import CharacterClassUpdate from './src/pages/CardSaga/CharacterClassCard/CharacterClassUpdate';
import UpgradeCard from './src/pages/CardSaga/UpgradeCard';
import UpgradeCreate from './src/pages/CardSaga/UpgradeCard/UpgradeCreate';
import UpgradeUpdate from './src/pages/CardSaga/UpgradeCard/UpgradeUpdate';
import Keyword from './src/pages/CardSaga/Keyword';

const MenuCardSaga = [
    {
        id: 'actionCard',
        name: 'Action Card',
        icon: 'icon-equalizer',
        path: 'action-card',
        component: ActionCard,
        isShown: 1,
    },
    {
        path: 'action-card/create',
        name: 'Action Card > Create',
        component: ActionCreate,
        isShown: 0,
    },
    {
        path: 'action-card/update/:id',
        name: 'Action Card > Update',
        component: ActionUpdate,
        isShown: 0,
    },
    {
        id: 'adventureCard',
        name: 'Adventure Card',
        icon: 'icon-layers',
        path: 'adventure-card',
        component: AdventureCard,
        isShown: 1,
    },
    {
        path: 'adventure-card/create',
        name: 'Adventure Card > Create',
        component: AdventureCreate,
        isShown: 0,
    },
    {
        path: 'adventure-card/update/:id',
        name: 'Adventure Card > Update',
        component: AdventureUpdate,
        isShown: 0,
    },
    {
        id: 'characterClassCard',
        name: 'Character Class Card',
        icon: 'icon-organization',
        path: 'character-class-card',
        component: CharacterClassCard,
        isShown: 1,
    },
    {
        path: 'character-class-card/create',
        name: 'Character Class Card > Create',
        component: CharacterClassCreate,
        isShown: 0,
    },
    {
        path: 'character-class-card/update/:id',
        name: 'Character Class Card > Update',
        component: CharacterClassUpdate,
        isShown: 0,
    },
    {
        id: 'powerCard',
        name: 'Power Card',
        icon: 'icon-energy',
        path: 'power-card',
        component: PowerCard,
        isShown: 1,
    },
    {
        path: 'power-card/create',
        name: 'Power Card > Create',
        component: PowerCreate,
        isShown: 0,
    },
    {
        path: 'power-card/update/:id',
        name: 'Power Card > Update',
        component: PowerUpdate,
        isShown: 0,
    },
    {
        id: 'upgradeCard',
        name: 'Upgrade Card',
        icon: 'icon-cup',
        path: 'upgrade-card',
        component: UpgradeCard,
        isShown: 1,
    },
    {
        path: 'upgrade-card/create',
        name: 'Upgrade Card > Create',
        component: UpgradeCreate,
        isShown: 0,
    },
    {
        path: 'upgrade-card/update/:id',
        name: 'Upgrade Card > Update',
        component: UpgradeUpdate,
        isShown: 0,
    },
    {
        id: 'biome',
        name: 'Biome',
        icon: 'icon-people',
        path: 'biomes',
        component: Biome,
        isShown: 1,
    },
    {
        path: 'biomes/create',
        name: 'Biome > Create',
        component: BiomeCreate,
        isShown: 0,
    },
    {
        path: 'biomes/update/:id',
        name: 'Biome > Update',
        component: BiomeUpdate,
        isShown: 0,
    },
    {
        id: 'Keyword',
        name: 'Keyword',
        icon: 'icon-key',
        path: 'keyword',
        component: Keyword,
        isShown: 1,
    },
];

export default MenuCardSaga;
